import React from "react";

export const PokemonImage = ({ src, alt, title }) => {
  return (
    <>
      <img className="single-pokemon-about" src={src} alt={alt} title={title} />
    </>
  );
};

export default PokemonImage;
